const config = require('@pcln/config')

const hosts =
  (config.datacenters &&
    config.datacenters[process.env.BOOTSTRAP_DC] &&
    config.datacenters[process.env.BOOTSTRAP_DC][process.env.BOOTSTRAP_ENV]) ||
  config.hosts ||
  {}

module.exports = {
  baseUrl: hosts.baseUrl || '/',
  baseUrlSecure: hosts.baseUrlSecure || '/',
  services: config.services || {},
}
